import axios from '../Backend';

export const getModules = async (queryObj = {}) => {
    try {
        const res = await axios.get('/api/v2/effective-crms/module', {
            params: queryObj, // Pass query parameters here
        });
        return res.data?.data?.data
    } catch (e) {
        console.log(`getModules :: Error=${e.response?.data ? e.response.data.message : e.message}`)
    }
}

export const getUserModules = async (moduleName) => {
    try {
        let urlPath = `/api/v2/effective-crms/module/user-modules`
        if (moduleName) {
            urlPath = `${urlPath}/${moduleName}`
        }
        const res = await axios.get(urlPath);
        return res.data?.data?.data
    } catch (e) {
        console.log(`getModules :: Error=${e.response?.data ? e.response.data.message : e.message}`)
    }
}

export const patchUserModule = async (patchObj) => {
    try {
        const res = await axios.patch('/api/v2/effective-crms/module/user-modules', patchObj);
        return res.data?.data?.data
    } catch (e) {
        console.log(`getModules :: Error=${e.response?.data ? e.response.data.message : e.message}`)
    }
}

export const updateCrmModule = async (patchObj) => {
    try {
        const res = await axios.patch(`/api/v2/effective-crms/module/${patchObj._id}`, patchObj);
        return res.data?.data?.data
    } catch (e) {
        const errorMsg = e.response?.data ? e.response.data.message : e.message
        console.log(`updateCrmModule :: Error=${errorMsg}`)
        throw new Error(errorMsg)
    }
}

export const createCrmModule = async (newModuleObj = {}) => {
    try {
        if (!newModuleObj.name || !newModuleObj.label || !newModuleObj.icon || !newModuleObj.crmName) throw new Error('Some required fields missed.')
        const res = await axios.post(`/api/v2/effective-crms/module/`, newModuleObj);
        return res.data?.data?.data
    } catch (e) {
        const errorMsg = e.response?.data?.message || e.message
        console.log(`updateCrmModule :: Error=${errorMsg}`)
        throw new Error(errorMsg)
    }
}

export const deleteModule = async (moduleId) => {
    try {
        if (!moduleId) throw new Error('Module not selected.')
        const res = await axios.delete(`/api/v2/effective-crms/module/${moduleId}`);
        return res.status == 204
    } catch (e) {
        const errorMsg = e.response?.data?.message || e.message
        console.log(`updateCrmModule :: Error=${errorMsg}`)
        throw new Error(errorMsg)
    }
}

export const syncCrmModules = async () => {
    try {
        const res = await axios.post('/api/v2/effective-crms/module/sync');
        return res.data
    } catch (e) {
        const errorMsg = e.response?.data?.message || e.message
        console.log(`syncCrmModules :: Error=${errorMsg}`)
        throw new Error(errorMsg)
    }
}